import script from "./RecentMap.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentMap.vue?vue&type=script&setup=true&lang=js"

import "./RecentMap.vue?vue&type=style&index=0&id=256be80e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256be80e"]])

export default __exports__